import { LazyAction, LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';

import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

const lazyModule = new LazyModule(() => import('./lazyIndex'));

const lazyInitializeCloudCacheMailboxService = new LazyAction(
    lazyModule,
    m => m.initializeCloudCacheMailboxService
);

runAfterInitialRender(() => {
    if (getUserConfiguration().SessionSettings.WebSessionType === WebSessionType.GMail) {
        lazyInitializeCloudCacheMailboxService.importAndExecute();
    }
});
